import React from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {SectionTitle} from './helpers';
import {
  getAutoCreatedSignalDefinitions,
  getIsFieldSignalFn,
} from '../../../../shared/signalDefinition';
import {getAgentFields} from '../../../../shared/agent';
import {useAgentBuilderServerState} from '../AgentBuilder.state';
import {useCustomer} from '../../../../hooks/api/metadata';
import {RawSignal} from '../../../signals';
import {getFieldLabel} from '../../../../shared/fields/types';

export const SignalsSection = () => {
  const {id: agentId, label: agentLabel, status} = useAgentBuilderServerState();
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];
  const signalDefinitions = useCustomer().signalDefinitions ?? [];

  const agentFields = getAgentFields({agentId, fieldDefinitions});
  const agentSignalDefinitions = agentFields.map((fieldDefinition) => {
    const isFieldSignalDefinition = getIsFieldSignalFn(fieldDefinition.id);
    const signals =
      status === 'draft'
        ? // If the agent is draft, we show the auto-created signals
          getAutoCreatedSignalDefinitions({
            agentLabel,
            fieldDefinition,
            signalDefinitions,
          })
        : // Otherwise, if the agent is published, we show the signals that are
          // associated with the field
          signalDefinitions.filter(isFieldSignalDefinition);

    return {
      fieldDefinition,
      signals,
    };
  });

  // Hide the section if there are no signals
  if (!agentSignalDefinitions.some(({signals}) => signals.length)) {
    return null;
  }

  return (
    <Flex direction="column" gap="4">
      <SectionTitle>Signals</SectionTitle>
      <Box color="kgray.300">
        On publish, signals will be automatically created for the following
        fields
      </Box>
      {agentSignalDefinitions.map(({fieldDefinition, signals}) => {
        if (!signals.length) {
          return null;
        }

        return (
          <Flex key={fieldDefinition.id.toString()} direction="column" gap="2">
            <Box>{getFieldLabel(fieldDefinition)}</Box>
            <Flex columnGap="4" rowGap="2" wrap="wrap">
              {signals.map((signal) => (
                <RawSignal
                  key={`${fieldDefinition.id}-${signal.label}`}
                  category={signal.category}
                  label={signal.label}
                  fontSize="sm"
                />
              ))}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
